module.exports = __webpack_public_path__ + "assets/filled-round-checkmark.6d0dcf1d.svg";